import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import type { ExploreItem } from '../types/onboarding';
import { explorePreviews } from '../data/screenshots';
interface ExploreGridProps {
  items: ExploreItem[];
}
export function ExploreGrid({
  items
}: ExploreGridProps) {
  return <div className="space-y-5" data-id="element-14" data-mp="3mwrsai4p0ozu">
      <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-15" data-mp="3mvzx38f0cta3">
        {items.map(item => {
        const Icon = item.icon;
        const preview = explorePreviews[item.name];
        return <li key={item.name} className={['group/card rounded-xl border border-white/10 bg-white/[0.05] p-4 transition-all duration-200 hover:-translate-y-1 hover:border-[#10b981]/45 hover:bg-[#10b981]/[0.07] hover:shadow-[0_0_0_1px_rgba(16,185,129,0.3),0_18px_50px_-20px_rgba(16,185,129,0.22)]', preview ? 'sm:col-span-2 lg:col-span-3' : ''].join(' ')} data-id="element-16" data-mp="3dx4m7j10qv0g">
              <Icon className="h-5 w-5 text-white/55 transition-colors duration-200 group-hover/card:text-[#10b981]" aria-hidden="true" data-id="element-17" data-mp="ixnm035kkje2" />
              <h3 className="mt-3.5 font-mono text-[13.5px] font-semibold tracking-tight text-white" data-id="element-18" data-mp="dwgabt0b3024">
                {item.name}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-white/75" data-id="element-19" data-mp="no41rtwv4h3l">
                {item.description}
              </p>

              {preview && <img src={preview} alt={`${item.name} preview`} loading="lazy" className="mt-4 block h-auto w-full rounded-lg border border-white/10 bg-black/40 object-contain" data-id="element-20" data-mp="mbk2t8xr2q" />}

              <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.18em] text-[#10b981] opacity-70 transition-opacity duration-200 group-hover/card:opacity-100" data-id="element-21" data-mp="4zyzkqvut46w">
                Ask us about it →
              </p>
            </li>;
      })}
      </ul>

      <div className="flex gap-3 rounded-xl border border-[#10b981]/25 bg-[#10b981]/[0.08] px-4 py-4 sm:px-5" data-id="element-22" data-mp="d1c9abyjlu51">
        <MessageCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#10b981]" aria-hidden="true" data-id="element-23" data-mp="hznhyjd3pylo" />
        <p className="text-[15px] leading-relaxed text-white" data-id="element-24" data-mp="mygxsifv21p0">
          Curious about any of these? Reach out and we&apos;ll walk you through it.
        </p>
      </div>
    </div>;
}